import React, { useEffect } from 'react';
import SignupForm from './components/SignupForm';

// Standalone signup page for an iPad left out on the counter.
//
// Deliberately has no navigation, no links off the page and no admin controls,
// so a customer cannot wander into the rest of the site. The form clears itself
// a few seconds after each successful signup, ready for the next person.
const RESET_AFTER_MS = 6000;

function NewsletterKiosk() {
  useEffect(() => {
    document.title = 'Join Our Mailing List | Vivat Alfa Winery';

    // Kiosks should not be indexed as a landing page for the winery.
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);

    return () => {
      document.head.removeChild(robots);
    };
  }, []);

  return (
    <div
      className="flex items-center justify-center px-6 py-10"
      style={{ minHeight: '100vh', backgroundColor: '#722f37' }}
    >
      <main className="w-full" style={{ maxWidth: '46rem' }}>
        <div className="text-center mb-10">
          <img
            src="/logo-mark.png"
            alt=""
            aria-hidden="true"
            className="mx-auto mb-4"
            style={{ height: '6rem', width: 'auto' }}
          />
          <h1 className="text-white font-bold mb-4" style={{ fontSize: '3rem', lineHeight: 1.1 }}>
            Vivat Alfa Winery
          </h1>
          <p className="text-gold" style={{ fontSize: '1.75rem' }}>
            Join our mailing list
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-10">
          <p className="text-center text-gray-600 mb-8" style={{ fontSize: '1.35rem' }}>
            Be the first to hear about new releases, events and exclusive offers.
          </p>

          <SignupForm size="large" resetAfterMs={RESET_AFTER_MS} />

          <p className="text-center text-gray-500 mt-8" style={{ fontSize: '1rem' }}>
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </main>
    </div>
  );
}

export default NewsletterKiosk;
